function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
}

let imageSelector = document.querySelector(
  ".gpo_custom-element .gpo_custom-dropzone__input"
);
if (imageSelector) {
  let dropZone_Element = document.querySelector(".gpo_custom-dropzone");
  let dropZone_image_representor = document.querySelector(".image-representor");
  let imageRepresentedBox = document.querySelector(
    ".image-representor .gpo-f-link"
  );
  let fileNameTag = document.querySelector(".image-representor .gpo-f-name");
  let removeImageRepresentator = document.querySelector(
    ".image-representor .gpo-f-rm"
  );
  let spinenrLoader = document.querySelector(".on-select-loader-wrapper");
  imageSelector.addEventListener("change", async (event) => {
    const file = event.target.files[0];

    if (file && /\.(jpe?g|png)$/i.test(file.name)) {
      try {
        const dataURL = await readFileAsDataURL(file);
        spinenrLoader.classList.remove("hidden");
        setTimeout(() => {
          spinenrLoader.classList.add("hidden");
          dropZone_Element.classList.add("hidden");
          dropZone_image_representor.classList.remove("hidden");
          imageRepresentedBox.innerHTML = `<img src="${dataURL}">`;
          if (document.querySelector(".productImagePreview")) {
            document.querySelector(".productImagePreview").src = dataURL;
          }

          imageRepresentedBox.href = dataURL;
          fileNameTag.textContent = file.name;

          if (document.querySelector(".live-image-div")) {
            let defaultimageTag = document.querySelector('[alt="EmptyPillow"]');
            var choosenImageSRC;
            var defaultImageSRC;

            if (defaultimageTag) {
              if (document.querySelector(".main-controllers")) {
                document
                  .querySelector(".main-controllers")
                  .classList.remove("hidden");
              }
              // imageSRC = imageTag.querySelector('img').src;
              defaultImageSRC = defaultimageTag.src;
             
              if(document.querySelector(".product-pillow") || document.querySelector(".product-pillow-art")){
                document.querySelector(
                ".frame_images_hider .frameImagePreview"
              ).src = defaultImageSRC;
              }
              
            }

            document.querySelector(".live-image-div").style.display = "none";
            document.querySelector(".frame_images_hider").style.display =
              "block";
          }
        }, 2000);
      } catch (error) {
        console.error("Error reading file:", error);
      }
    } else {
      alert("File is not an image.");
    }
  });
  removeImageRepresentator.addEventListener("click", function (e) {
    e.preventDefault();
    dropZone_image_representor.classList.add("hidden");
    dropZone_Element.classList.remove("hidden");
    imageSelector.value = "";
    if (document.querySelector(".live-image-div")) {
      document.querySelector(".live-image-div").style.display = "block";
      document.querySelector(".frame_images_hider").style.display = "none";
    }

    let defaultimageTag = document.querySelector('[alt="EmptyPillow"]');

    if (defaultimageTag) {
      if (document.querySelector(".main-controllers")) {
        document.querySelector(".main-controllers").classList.remove("hidden");
      }
    }
  });
  async function dataUrlToFile(dataUrl, fileName) {
    // const res: Response = await fetch(dataUrl);
    // const blob: Blob = await res.blob();
    // return new File([blob], fileName, { type: "image/png" });
    fetch(dataUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], "File name", { type: "image/png" });

        if (document.querySelector("#data-custom-desgin")) {
          let dataTransfer = new DataTransfer();
          dataTransfer.items.add(file);

          document.querySelector("#data-custom-desgin").files =
            dataTransfer.files;
          return file;
        }

        return file;
      });
  }
  var atcButton;
  // async function getScreenshotOfElement() {
  //   let div = document.querySelector(".frame_images_hider");
  //   html2canvas(div).then(async function (canvas) {
  //     let form = document.querySelector('[data-block-type="buy-buttons"] form');
  //     // document.querySelector(".shopify-product-form");
  //     let base64Image = canvas.toDataURL("image/png");
  //     let inputField = document.createElement("input");
  //     // inputField.value = base64Image;
  //     inputField.id = "data-custom-desgin";
  //     //

  //     inputField.name = "properties[finalDesign]";
  //     inputField.type = "file";
  //     form.appendChild(inputField);
  //     let file = await dataUrlToFile(base64Image, "Desgin.jpg");
  //     setTimeout(() => {
  //       return file;
  //     }, 1000);
  //     // form.submit();
  //   });
  // }
}
// const find_atc = setInterval(() => {
//   atcButton = document.querySelector(
//     ".shopify-product-form .gpo-clone-atc-button"
//   );
//   if (find_atc != null) {
//     atcButton.addEventListener("click", function () {
//       event.preventDefault;
//       getScreenshotOfElement();
//     });
//     clearInterval(find_atc);
//   }
// }, 200);
const image = document.querySelector(".frameImagePreview");
const image_ = document.querySelector(".productImagePreview");
if(typeof template == "undefined"){
  let template = document.querySelector('.getTemplateName').textContent;
  if(template == 'product.pillow'){
    let pillowTempImageSrc = document.querySelector(
      'product-gallery-navigation [alt="raw-image"]'
    ).src;
    let emptyPillowTempImageSrc = document.querySelector(
      'product-gallery-navigation [alt="EmptyPillow"]'
    ).src;
    if (pillowTempImageSrc) {
      image_.src = pillowTempImageSrc;
      image.src = emptyPillowTempImageSrc;
      document.querySelector(".live-image-div").style.display = "none";
      document.querySelector(".frame_images_hider").style.display = "block";
      document.querySelector(".main-controllers").classList.remove("hidden");
    }
  }
}
else{

  if(template == 'product.pillow'){
    let pillowTempImageSrc = document.querySelector(
      'product-gallery-navigation [alt="raw-image"]'
    ).src;
    let emptyPillowTempImageSrc = document.querySelector(
      'product-gallery-navigation [alt="EmptyPillow"]'
    ).src;
    if (pillowTempImageSrc) {
      image_.src = pillowTempImageSrc;
      image.src = emptyPillowTempImageSrc;
      document.querySelector(".live-image-div").style.display = "none";
      document.querySelector(".frame_images_hider").style.display = "block";
      document.querySelector(".main-controllers").classList.remove("hidden");
    }
  }
  
}




let isDragging = false;
let initialX, initialY, offsetX, offsetY;

image.addEventListener("mousedown", function (event) {
  isDragging = true;
  initialX = event.clientX;
  initialY = event.clientY;
  offsetX = image.offsetLeft;
  offsetY = image.offsetTop;
  image.style.cursor = "grabbing";
});

document.addEventListener("mousemove", function (event) {
  if (!isDragging) return;
  const deltaX = event.clientX - initialX;
  const deltaY = event.clientY - initialY;
  image_.style.left = offsetX + deltaX + "px";
  image_.style.top = offsetY + deltaY + "px";
});

document.addEventListener("mouseup", function (event) {
  if (isDragging) {
    isDragging = false;
    image_.style.cursor = "grab";
  }
});

image.addEventListener("click", function (event) {
  event.stopPropagation(); // Prevent click event from bubbling to document
  image_.classList.toggle("zoomed");
});
